export const navBar = [
    {
        id:1,
        name:"About",
        path:"#about"
    },
    {
        id:2,
        name:"Service",
        path:"#service"
    },
    {
        id:3,
        name:"Projects",
        path:"#projects"
    }

]